<template>
  <main class="home-page flex flex-col align-center p-5 items-center justify-center">
    <div class="video-wrapper hidden xl:block">
      <video class="home-background" autoplay loop muted>
        <source src="@/assets/videos/home_background.webm" type="video/webm" codecs=vp9>
        <source src="@/assets/videos/home_background.mp4" type="video/mp4">
        Sorry, your browser doesn't support embedded videos.
      </video>
    </div>
    <h1 class="text-4xl font-bold text-white text-center mb-12">iM FARMING Savings Calculator</h1>
    <p class="text-lg text-white mb-14 max-w-xl lg:max-w-3xl 2xl:max-w-4xl">
      {{ this.$translations[this.$root.language].intro }}
    </p>
    <router-link class="hover-green-bg bg-green text-center text-white font-bold p-5 rounded-sm shadow-sm max-w-sm px-20" to="/calculator">
      {{ this.$translations[this.$root.language].proceedToCalculation }}
    </router-link>
  </main>
</template>

<style lang="scss" scoped>
  main {
    position: relative;
  }
  .video-wrapper {
    background-color: black;
    z-index: -1;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  video {
    width: 100%;
    height: 100%;
    opacity: 0.7;
    object-fit: cover;
    border: unset;
  }
  @media(min-width: 1280px) {
    main {
      background: unset;
    }
  }
</style>

<script>
export default {
   mounted: function () {
    if (this.$root.cookiePolicySelected === false) {
      var cookiePolicy = document.getElementById('cookie-policy')
      cookiePolicy.classList.remove('hidden')
    }
  }
}
</script>